module.exports = __webpack_public_path__ + "static/media/alert-icon.64cd219a.svg";